import { Search } from "lucide-react";

import "./DeliveryFilters.css";

function DeliveryFilters({
    filters,
    onChange,
}) {

    return (

        <div className="delivery-filters">

            <div className="delivery-search">

                <Search size={18} />

                <input
                    type="text"
                    placeholder="Search by name, email, phone or vehicle..."
                    value={filters.search}
                    onChange={(e) =>
                        onChange("search", e.target.value)
                    }
                />

            </div>

            <select
                value={filters.status}
                onChange={(e) =>
                    onChange("status", e.target.value)
                }
            >

                <option value="">All Status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
                <option value="Suspended">Suspended</option>

            </select>

            <select
                value={filters.vehicle}
                onChange={(e) =>
                    onChange("vehicle", e.target.value)
                }
            >

                <option value="">All Vehicles</option>
                <option value="Bike">Bike</option>
                <option value="Scooter">Scooter</option>
                <option value="Cycle">Cycle</option>
                <option value="Car">Car</option>

            </select>

            <input
                type="text"
                placeholder="City"
                value={filters.city}
                onChange={(e) =>
                    onChange("city", e.target.value)
                }
            />

            <select
                value={filters.sort}
                onChange={(e) =>
                    onChange("sort", e.target.value)
                }
            >

                <option value="latest">Latest</option>
                <option value="oldest">Oldest</option>
                <option value="az">Name A-Z</option>
                <option value="za">Name Z-A</option>

            </select>

        </div>

    );

}

export default DeliveryFilters;